import { render, staticRenderFns } from "./InventarioPilhas.vue?vue&type=template&id=36b1a09d&scoped=true"
import script from "./InventarioPilhas.vue?vue&type=script&lang=js"
export * from "./InventarioPilhas.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=36b1a09d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1a09d",
  null
  
)

export default component.exports